<template>
    <v-snackbar
        absolute
        right
        shaped
        top
        max-width="200px"
        :timeout="timeout"
        :value="value.visible"
        :color="value.color"
    >
        {{ value.text }}
    </v-snackbar>
</template>

<script>
export default {
    name: "BotSnackbar",

    props: ["value"],

    data() {
        return {
            timeout: 60 * 1000,//1 phút
        };
    },

    watch: {
        value: {
            handler(val) {
                if (!val.visible) return;
                setTimeout(() => {
                    this.value.visible = false;
                }, this.timeout);
            },
            deep: true,
        },
    },

    computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus"></style>



// WEBPACK FOOTER //
// bot.snackbar.vue